<div class="flex">
  <app-jkcombobox class="jk-combobox-border" [styleDisplay]="'flex'" label="帳號" [(value)]="account" [items]="accountList()">
  </app-jkcombobox>
  <button mat-flat-button (click)="doQuery()">
    查詢
  </button>
  </div>
  <app-jkgridwin label="未平倉" [width]="width()" [height]="200" ariaLabel=""
  (afterGridReady)="afterGridReady($event)">
  </app-jkgridwin>

